(ns manage.poi.locations.view
  (:require ["@mui/material/Autocomplete$default" :as Autocomplete]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/TextField$default" :as TextField]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium useGridApiRef]]
            ["src/svg/shapes/rectangle/rectangle-split-3x1.svg$default" :as ColumnsIcon]
            [cljs-bean.core :refer [->clj]]
            [common.queries :refer [use-query]]
            [common.resource.query.poi :as poi.q]
            [manage.poi.locations.columns :refer [get-row-id location-columns sortable-fields]]
            [manage.poi.shared :refer [cursor-pagination use-cursor-pagination]]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui] :as uix]
            [uix.re-frame :refer [use-subscribe]]))

(defui locations []
  (let [api-ref (useGridApiRef)
        {:keys [advertiser-id]} (use-subscribe [:url-context])
        {dataset-ready :isSuccess} (use-query (poi.q/ensure-dataset {:advertiser-id advertiser-id}))

        [search-input set-search-input] (uix/use-state "")
        [search-query set-search-query] (uix/use-state "")
        [selected-labels set-selected-labels] (uix/use-state [])
        [sort-model set-sort-model] (uix/use-state #js [])
        ^js sort-item (some-> sort-model (aget 0))
        order-by (some-> sort-item .-field sortable-fields)
        sort-dir (some-> sort-item .-sort)
        {:keys [cursor reset page-props]} (use-cursor-pagination)

        _ (uix/use-effect
           (fn []
             (let [timer (js/setTimeout #(do (set-search-query search-input)
                                             (reset))
                                        300)]
               #(js/clearTimeout timer)))
           [search-input reset])

        {available-labels :data} (use-query (poi.q/label-options-query {:advertiser-id advertiser-id
                                                                        :enabled? dataset-ready}))

        {page-data :data isPending :isPending}
        (use-query (poi.q/locations-query {:advertiser-id advertiser-id
                                           :page-after (:page-after cursor)
                                           :page-before (:page-before cursor)
                                           :q search-query
                                           :labels selected-labels
                                           :order-by order-by
                                           :sort-dir sort-dir
                                           :enabled? dataset-ready}))

        {:keys [items pagination-props]} (page-props page-data)]
    ($ :<>
       ($ Stack {:direction "row" :alignItems "center" :p 1 :spacing 1}
          ($ TextField {:size "small"
                        :placeholder "Search locations..."
                        :value search-input
                        :onChange #(set-search-input (.. % -target -value))
                        :sx #js {:width "300px"}})
          ($ Autocomplete
             {:multiple true
              :size "small"
              :options (to-array (or available-labels []))
              :value (to-array selected-labels)
              :onChange (fn [_ value]
                          (set-selected-labels (js->clj value))
                          (reset))
              :renderInput (fn [^js props]
                             ($ TextField (js/Object.assign props
                                                            #js {:placeholder (when (empty? selected-labels)
                                                                                "Filter by label...")})))
              :sx #js {:minWidth "300px"}})
          ($ :div {:style {:flex 1}})
          ($ Button {:endIcon ($ ColumnsIcon)
                     :onClick #(.. api-ref -current (showPreferences "columns"))}
             "Columns")
          ($ Button {:color "error"
                     :onClick #(rf/dispatch [:modal/open {:id :poi/confirm-delete-all-locations}])}
             "Delete all locations")
          ($ Button {:variant "outlined"
                     :onClick #(rf/dispatch [:ocp/open {:id :poi/upload-csv}])}
             "Upload CSV")
          ($ Button {:variant "contained"
                     :onClick #(rf/dispatch [:ocp/open {:id :poi/create-location}])}
             "+ New Location"))
       ($ DataGridPremium
          {:apiRef api-ref
           :columns (location-columns (fn [{:keys [location-id location-name]}]
                                        (rf/dispatch [:modal/open {:id :poi/confirm-delete-location
                                                                   :props {:location-id location-id
                                                                           :location-name location-name}}])))
           :loading isPending
           :rows (to-array items)
           :getRowId get-row-id
           :onRowClick (fn [^js params]
                         (rf/dispatch [:ocp/open {:id :poi/location
                                                  :props {:location (->clj (.-row params))}}]))
           :disableRowSelectionOnClick true
           :sortingMode "server"
           :sortModel sort-model
           :onSortModelChange (fn [model]
                                (set-sort-model model)
                                (reset))
           :disableColumnFilter true
           :hideFooter true
           :localeText #js {:noRowsLabel "No locations found"}
           :initialState #js {:columns #js {:columnVisibilityModel #js {:monday false :tuesday false :wednesday false
                                                                        :thursday false :friday false :saturday false
                                                                        :sunday false
                                                                        :lat false :lon false
                                                                        :created-at false}}}
           :sx #js {:maxHeight "70rem"}})
       ($ cursor-pagination pagination-props))))
